// extracted by mini-css-extract-plugin
export default {"container":"style_container__8tC2n","grid":"style_grid__23K7e"};